import React, { useState } from 'react';
import PropTypes from 'prop-types';

// Material
import Grid from '@mui/material/Grid';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';

// Components
import Input from '../../../../components/inputs/input';

// Hooks
import useReception from '../../../../hooks/reception/useReception';

const EditDetailModal = ({ open, detail, onClose }) => {
    const { movement, editProduct } = useReception();
    const [quantity, setQuantity] = useState(detail.quantity);

    const handleSave = () => {
        const payload = {
            quantity,
            difference: quantity - detail.plannedQuantity,
            differenceToShow: `${quantity - detail.plannedQuantity > 0 ? '+' : ''}${quantity - detail.plannedQuantity}`,
            plannedQuantity: detail.plannedQuantity
        };

        editProduct(detail.refId, payload);
        onClose();
    }

    const handleNumberChange = (event) => {
        const num = Number.parseInt(event.target.value);
        if (!isNaN(num) && num >= 0)
            setQuantity(num);
    }

    return (
        <Dialog
            open={open}
            onClose={onClose}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
        >
            <DialogTitle id="alert-dialog-title">
                {`Detalle ${detail.refId}`}
            </DialogTitle>
            <DialogContent style={{ minWidth: 430 }}>
                <Grid container direction='column' spacing={1}>
                    {
                        !movement.id &&
                        <Grid>
                            <Input
                                fullWidth
                                size='small'
                                name='quantity'
                                label='Cantidad'
                                onChange={handleNumberChange}
                                value={quantity}
                                type='number'
                            />
                        </Grid>
                    }
                </Grid>
            </DialogContent>
            <DialogActions>
                <Button
                    onClick={onClose}
                    color="primary"
                >
                    Cancelar
                </Button>
                <Button
                    onClick={handleSave}
                    color="primary"
                    variant='outlined'
                    autoFocus
                >
                    Guardar
                </Button>
            </DialogActions>
        </Dialog>
    );
}

EditDetailModal.defaultProps = {
    onClose: () => { }
}

EditDetailModal.prototype = {
    onClose: PropTypes.func,
    open: PropTypes.bool,
    detail: PropTypes.object
}

export default EditDetailModal;